export const DevelopmentModeDetector = {
  computed: {
    development() {
      return process.env.NODE_ENV !== "production";
    },
    exclusive_termbank() {
      return window.location.hostname === "termbank.valeontis.com";
    }
  }
};
